
    import { mapGetters } from "vuex"
    import { PropType, defineComponent } from "vue"
    import KeyWarning from "./KeyWarning.vue"
    import LogIn from "../auth/LogIn.vue"
    import { CreateCompletionRequest } from "openai"

    export default defineComponent({
        props: {
            isLoading: {
                type: Boolean,
                default: () => false
            },
            disabled: {
                type: Boolean,
                default: () => false
            },
            showKeyDescription: {
                type: Boolean,
                default: () => false
            },
        },
        components: {
            KeyWarning,
            LogIn
        },
        // emits: ['update:modelValue'], this.$emit('update:modelValue', title)
        data() {
            return {

            }
        },
        computed: {
            ...mapGetters(["user", "guest"]),
            left(): number {
                if (this.user) {
                    return (this.user?.queriesLimit || 10) - (this.user?.queriesUsed || 0)
                } else {
                    return 6 - (this.guest?.queriesUsed || 0)
                }
            },

        },
        methods: {

        },
    })

    